export default __webpack_public_path__ + "static/media/Music-Soulful.25444c20.png";